import getSubscribeOnce from './subscribeOnce';

function getClient(_ref) {
  var messageBus = _ref.messageBus,
      readyTopic = _ref.readyTopic,
      operationSelector = _ref.operationSelector;
  var operationAvailable = new Promise(function (resolve) {
    getSubscribeOnce(messageBus)(readyTopic, resolve);
  });
  var operations = {
    SUBSCRIBE: 'subscribe',
    UNSUBSCRIBE: 'unsubscribe',
    UNSUBSCRIBE_ALL: 'unsubscribeAll'
  };
  return {
    subscribe: function subscribe(payload) {
      return new Promise(function (resolve) {
        operationAvailable.then(function () {
          var _operationSelector;

          (_operationSelector = operationSelector(operations.SUBSCRIBE)) === null || _operationSelector === void 0 ? void 0 : _operationSelector(payload);
          resolve();
        });
      });
    },
    unsubscribe: function unsubscribe(payload) {
      return new Promise(function (resolve) {
        operationAvailable.then(function () {
          var _operationSelector2;

          (_operationSelector2 = operationSelector(operations.UNSUBSCRIBE)) === null || _operationSelector2 === void 0 ? void 0 : _operationSelector2(payload);
          resolve();
        });
      });
    },
    unsubscribeAll: function unsubscribeAll(payload) {
      return new Promise(function (resolve) {
        operationAvailable.then(function () {
          var _operationSelector3;

          (_operationSelector3 = operationSelector(operations.UNSUBSCRIBE_ALL)) === null || _operationSelector3 === void 0 ? void 0 : _operationSelector3(payload);
          resolve();
        });
      });
    }
  };
}

export default getClient;